import React from 'react'
import Container from '../components/Container'
import Input from '../components/Input'
import Logo from '../assets/images/LOGO.svg'
import IconButton from '../components/IconButton'

function Footer() {
    return (
        <div className='pt-10 pb-5'>
            <Container>
                <div className='flex gap-10 md:gap-16 flex-wrap lg:flex-nowrap'>
                    <div className='basis-full flex flex-col items-center lg:items-start gap-5 text-center lg:text-left lg:flex-1'>
                        <img src={Logo} width={150} height={75} alt="" />
                        <div>
                            <span className='font-light'>A trusted locksmith service provider committed to ensuring the safety and security of your home, business, and vehicle.</span>
                        </div>
                    </div>
                    <div>
                        <div className="pb-5">
                            <span className='text-xl font-bold'>Company</span>
                        </div>
                        <div className='flex flex-col gap-4'>
                            <a href="#home">Home</a>
                            <a href="#services">Services</a>
                            <a href="#prices">Prices</a>
                            <a href="#about-us">About Us</a>
                            <a href="#contact-us">Contcat Us</a>
                        </div>
                    </div>
                    <div>
                        <div className="pb-5">
                            <span className='text-xl font-bold'>Know More</span>
                        </div>
                        <div className='flex flex-col gap-4'>
                            <a href="/privacy">Privacy Policy</a>
                            <a href="/terms">Terms & conditions</a>
                        </div>
                    </div>
                    <div className='flex-1'>
                        <div className="pb-5">
                            <span className='text-xl font-bold'>Newsletter</span>
                        </div>
                        <div className='flex flex-col gap-4'>
                            <Input
                                label={'Enter your email address'}
                                placeholder={'jsmaith@email.com'}
                            />
                            <IconButton>
                                Send
                            </IconButton>
                        </div>
                    </div>
                </div>
            </Container>
            <div className="max-w-[1300px] mx-auto">
                <hr className='mb-5 mt-10' />
                <div className='px-4 text-center'>
                    <span>2025 “Schliesswerk” All Rights Received</span>
                </div>
            </div>
        </div>
    )
}

export default Footer